<template>
  <div class="search-picker" @mouseenter="openState = true" @mouseleave="openState = false">
    <div class="input-placeholder mw-150">
      <div class="input-icon">
        <img src="/static/img/users-light.svg" alt="">
      </div>
      <span class="value" v-if="count < 2">{{$t('v2.travelers.label.singular', count)}}</span>
      <span class="value" v-else>{{$t('v2.travelers.label.plural', count)}}</span>
    </div>
    <div class="input-dropdown" :class="{open: openState}">
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">{{ $t('v2.travelers.adults.title') }}</span>
          <span class="item-desc">{{ $t('v2.travelers.adults.desc') }}</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="adults <= minAdults" v-on:click="addAdults(-1)"/>
          <div class="counter">{{ adults }}</div>
          <plus-svg :disabled="adults >= maxAdults" v-on:click="addAdults(1)"/>
        </div>
      </div>
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">{{ $t('v2.travelers.children.title') }}</span>
          <span class="item-desc">{{ $t('v2.travelers.children.desc') }}</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="children <= minChildren" v-on:click="addChildren(-1)"/>
          <div class="counter">{{ children }}</div>
          <plus-svg :disabled="children >= maxChildren" v-on:click="addChildren(1)"/>
        </div>
      </div>
      <div class="list-item">
        <div class="name-group">
          <span class="item-name">{{ $t('v2.travelers.babies.title') }}</span>
          <span class="item-desc">{{ $t('v2.travelers.babies.desc') }}</span>
        </div>
        <div class="picker-group">
          <minus-svg :disabled="babies <= minBabies" v-on:click="addBabies(-1)"/>
          <div class="counter">{{ babies }}</div>
          <plus-svg :disabled="babies >= maxBabies" v-on:click="addBabies(1)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MinusSvg from "../../../components/svg/minus-svg";
import PlusSvg from "../../../components/svg/plus-svg";
import {
  hasValue, initializable,
  withErrors,
  withEventDispatcher,
  withIcon,
  withPlaceholder
} from "../../../components/mixins/input.mixin";
export default {
  name: "search-travelers",
  components: {PlusSvg, MinusSvg},
  mixins: [hasValue('content'), withErrors, withIcon, withPlaceholder, withEventDispatcher, initializable],
  computed: {
    count() {
      return this.adults + this.children;
    },
    minAdults() {
      return 1;
    },
    maxAdults() {
      return 5 - this.children;
    },
    minChildren() {
      return 0;
    },
    maxChildren() {
      return 5 - this.adults;
    },
    minBabies() {
      return 0;
    },
    maxBabies() {
      return 1;
    }
  },
  data () {
    return {
      adults: this.$store.state.search.search.travelers.adults,
      children: this.$store.state.search.search.travelers.children,
      babies: this.$store.state.search.search.travelers.babies,
      openState: false
    }
  },
  methods: {
    updateValue(value) {
      this.$store.commit('search/SET_SEARCH_TRAVELERS', value);
      this.$emit('input', value);
    },
    addAdults (v) {
      if (this.adults + v > this.maxAdults || this.adults + v < this.minAdults) return;
      this.adults += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    },
    addChildren (v) {
      if (this.children + v > this.maxChildren || this.children + v < this.minChildren) return;
      this.children += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    },
    addBabies (v) {
      if (this.babies + v > this.maxBabies || this.babies + v < this.minBabies) return;
      this.babies += v;
      this.updateValue({
        adults: this.adults,
        children: this.children,
        babies: this.babies
      });
    }
  }
}
</script>

<style scoped>
  .input-dropdown:not(.open) {
    display: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/picker/search-travelers.vue